import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles(theme =>
  createStyles({
    autocomplete: {
      '& .MuiAutocomplete-paper': {
        borderRadius: '8px',
        borderWidth: '1px',
        borderColor: STYLE.COLOR.STROKE_DEFAULT,
        borderStyle: 'solid',
        backgroundColor: STYLE.COLOR.WHITE,
        boxShadow: 'none',
        marginTop: '4px',
      },
      '& .MuiAutocomplete-listbox': {
        overflowY: 'auto',
        padding: '0',
        '& .MuiAutocomplete-option': {
          minHeight: '44px',
          height: 'auto',
          padding: '10px 15px',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
        },
      },
    },
    option: {
      minHeight: '44px !important',
      height: 'auto !important',
      padding: '10px 15px !important',
      fontWeight: '400',
      fontSize: `14px`,
      lineHeight: '20px',
      color: STYLE.COLOR.TEXT1,
      whiteSpace: 'normal !important',
      wordBreak: 'break-word',
      '&.MuiAutocomplete-option': {
        minHeight: '44px !important',
        height: 'auto !important',
        whiteSpace: 'normal !important',
      },
    },
    selectedOption: {
      backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
      color: STYLE.COLOR.WHITE,
    },
    addOption: {
      color: STYLE.COLOR.ACCENT_PRIMARY,
      // fontWeight: '600',
    },
    dropdownIcon: {
      transition: 'all 0.2s ease-in',
      cursor: 'pointer',
    },
    dropdownIconRotated: {
      transform: 'rotate(180deg)',
      transition: 'all 0.2s ease-in',
    },
    groupHeader: {
      padding: '10px 15px',
      fontWeight: '600',
      fontSize: '12px',
      lineHeight: '16px',
      color: STYLE.COLOR.TEXT2,
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
      textTransform: 'uppercase',
    },
    groupOptions: {
      // Options within group
    },
  }),
);
